import { c as _c } from "react/compiler-runtime";
import Oddset from '@svs/ui/react/brands/Oddset';
import { Skeleton } from '@svs/ui/react/skeleton';

/**
 * Renders skeleton loading state while loading.
 *
 * @returns Component
 */
export default function QuickBetSkeleton() {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Oddset className="mb-3" width={150} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Skeleton className="mb-3 h-4 w-24" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <section className="mb-7">{t1}<div className="mb-3 flex w-full gap-3"><Skeleton className="h-17 w-1/3" /><Skeleton className="h-17 w-1/3" /><Skeleton className="h-17 w-1/3" /></div></section>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Skeleton className="mb-3 h-4 w-36" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="mb-3 flex w-full gap-3"><Skeleton className="h-17 w-1/2" /><Skeleton className="h-17 w-1/2" /></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="mb-3 flex w-full gap-3"><Skeleton className="h-17 w-1/2" /><Skeleton className="h-17 w-1/2" /></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="mb-3 flex w-full gap-3"><Skeleton className="h-17 w-1/2" /><Skeleton className="h-17 w-1/2" /></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <section className="mb-7">{t3}{t4}{t5}{t6}<div className="mb-3 flex w-full gap-3"><Skeleton className="h-17 w-1/2" /><Skeleton className="h-17 w-1/2" /></div></section>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Skeleton className="mb-3 h-4 w-24" />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <section className="theme-oddset-light bg-surface text-surface-fg h-full overflow-auto">{t0} {t2}{t7}<section className="mb-7">{t8}<div className="mb-3 flex w-full gap-3"><Skeleton className="h-17 w-1/3" /><Skeleton className="h-17 w-1/3" /><Skeleton className="h-17 w-1/3" /></div></section></section>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  return t9;
}